<div class="user-edit-page">
  @if (isLoading()) {
    <zag-loading-state [message]="'common.loading' | translate" />
  } @else if (error()) {
    <zag-error-state
      [message]="error()!"
      [backLink]="router.url.includes('/admin/') ? '/admin/users' : '/settings/users'"
      [backText]="'common.back' | translate"
    />
  } @else {
    <ng-template zagPageActions>
      <button zagButton type="button" [disabled]="isSaving() || !form.valid" (click)="saveAll()">
        {{ 'common.save' | translate }}
      </button>
    </ng-template>

    <zag-entity-detail-layout>
      <div slot="sidebar">
        <!-- Profile Card -->
        <zag-profile-summary-card
          [avatarName]="invitationEmail()"
          [subtitle]="'settings.users.invite.pending.badge' | translate"
          [quickActionsTitle]="'common.quickActions' | translate"
          [quickActions]="quickActions()"
          [dangerActions]="dangerActions()"
          (quickActionClick)="onQuickAction($event)"
          (dangerActionClick)="onDangerAction($event)"
        />

        <!-- Info Card -->
        <div class="user-edit-page__sidebar-card">
          <h3 class="user-edit-page__card-title">
            {{ 'settings.users.invite.details' | translate }}
          </h3>
          <div class="user-edit-page__card-list">
            <div class="user-edit-page__card-item">
              <span zagIcon="person" class="user-edit-page__card-item-icon"></span>
              <span class="user-edit-page__card-item-text">{{ inviterName() }}</span>
            </div>
            <div class="user-edit-page__card-item">
              <span zagIcon="calendar_today" class="user-edit-page__card-item-icon"></span>
              <span class="user-edit-page__card-item-text">{{ createdAt() | zagDate }}</span>
            </div>
          </div>
        </div>
      </div>

      <div slot="content">
        <form [formGroup]="form">
          <zag-accordion>
            <!-- General Section -->
            <zag-accordion-item [title]="'common.general' | translate" icon="settings" [expanded]="true">
              <div class="user-edit-page__section">
                <div class="user-edit-page__form-field">
                  <label class="user-edit-page__label" for="invitation-name">
                    {{ 'settings.users.invite.name' | translate }}
                  </label>
                  <input
                    id="invitation-name"
                    type="text"
                    formControlName="name"
                    class="user-edit-page__input"
                    [placeholder]="'settings.users.invite.namePlaceholder' | translate"
                  />
                </div>

                <div class="user-edit-page__form-field">
                  <label class="user-edit-page__label" for="invitation-message">
                    {{ 'settings.users.invite.message' | translate }}
                  </label>
                  <textarea
                    id="invitation-message"
                    formControlName="message"
                    class="user-edit-page__textarea"
                    rows="4"
                    [placeholder]="'settings.users.invite.messagePlaceholder' | translate"
                  ></textarea>
                </div>
              </div>
            </zag-accordion-item>

            <!-- Roles Section -->
            <zag-accordion-item [title]="'settings.users.sections.directRoles' | translate" icon="security" [expanded]="true">
              <div class="user-edit-page__section">
                <p class="user-edit-page__section-description">
                  {{ 'settings.users.directRolesDescription' | translate }}
                </p>

                @if (rolesLoading()) {
                  <div class="user-edit-page__loading">
                    <span zagIcon="sync" class="spinning"></span>
                    <p>{{ 'common.loading' | translate }}</p>
                  </div>
                } @else {
                  <div class="user-edit-page__role-list">
                    @for (role of availableRoles(); track role.id) {
                      <zag-selection-row
                        [label]="role.id"
                        [description]="role.description ?? null"
                        [checked]="selectedRoleIds().has(role.id)"
                        (checkedChange)="onRoleToggle(role.id, $event)"
                      />
                    } @empty {
                      <p class="user-edit-page__empty">
                        {{ 'settings.users.noRolesAvailable' | translate }}
                      </p>
                    }
                  </div>
                }
              </div>
            </zag-accordion-item>
          </zag-accordion>
        </form>
      </div>
    </zag-entity-detail-layout>
  }
</div>
